import React from "react";
import CostCenterList from "./CostCenterList";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";

interface Props {
  selectedCostCenters: server.dto.CostCenter[]
  onChange: (newCostCenters: server.dto.CostCenter[]) => void
}

const CostCenterMultiPicker = (props: Props) => {
  return <MultiPickerSelectedItems
    selectedItems={props.selectedCostCenters}
    onRemove={props.onChange}
    getId={costCenter => costCenter.costCenterId}
    getLabel={costCenter => <div>
      {costCenter.internalId}
    </div>}
  >
    <CostCenterList
      onItemSelected={(item) => props.onChange([...props.selectedCostCenters, item])}
      excludeKeys={props.selectedCostCenters.map(cc => cc.costCenterId)}
    />
  </MultiPickerSelectedItems>;
};

export default CostCenterMultiPicker;